import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-section-title',
  templateUrl: './section-title.html',
  styleUrls: ['./section-title.css'],
})
export class SectionTitle {
  @Input() title: string = '';
  @Input() id: string = 'section-title';
}
